import { api, tokenStore } from './client'
import type { CurrentUser } from '../auth/AuthContext'

export interface Session {
  id: string
  userAgent: string | null
  ipAddress: string | null
  createdAt: string
  lastUsedAt: string
  expiresAt: string
  isCurrent: boolean
}

export const requestPasswordReset = (userNameOrEmail: string) =>
  api.post<{ message: string }>('/auth/forgot-password', { userNameOrEmail }).then((r) => r.data)

interface CompletePasswordResponse { accessToken: string; expiresAt: string; user: CurrentUser }

/**
 * Comune pentru resetare și acceptare invitație — ambele întorc un token nou
 * de acces, la fel ca login-ul, ca utilizatorul să nu mai treacă printr-un pas
 * suplimentar după ce și-a setat parola.
 */
async function completePassword(url: string, token: string, newPassword: string): Promise<CurrentUser> {
  const { data } = await api.post<CompletePasswordResponse>(url, { token, newPassword })
  tokenStore.set(data.accessToken)
  return data.user
}

export const resetPassword = (token: string, newPassword: string) =>
  completePassword('/auth/reset-password', token, newPassword)

export const acceptInvitation = (token: string, newPassword: string) =>
  completePassword('/auth/accept-invitation', token, newPassword)

export const getSessions = () => api.get<Session[]>('/auth/sessions').then((r) => r.data)
export const revokeSession = (id: string) => api.post(`/auth/sessions/${id}/revoke`)
